(() => {
  const grid = document.querySelector('[data-sa2-grid]');
  const pager = document.querySelector('[data-sa2-pag]');
  const filters = document.querySelector('[data-sa2-filters]');
  const search = document.querySelector('[data-sa2-search]');
  if (!grid || !pager || !filters || !search) return;
  const clear = document.querySelector('[data-sa2-search-clear]');
  const empty = document.querySelector('[data-sa2-no-results]');
  const loading = document.querySelector('[data-sa2-loading]');
  const size = 24;
  const initialPage = Number(pager.dataset.currentPage) || 1;
  const totalPages = Number(pager.dataset.totalPages) || 1;
  const params = new URLSearchParams(location.search);
  let page = initialPage;
  let category = params.get('bar_filter') || params.get('filter') || 'all';
  let query = params.get('bar_q') || '';
  let cards = [];
  let ready = false;
  const buttons = [...filters.querySelectorAll('button')];
  if (!buttons.some(button => button.dataset.filter === category)) category = 'all';
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  function enableControls(enabled) {
    buttons.forEach(button => { button.disabled = !enabled; });
    search.disabled = !enabled;
  }
  function urlFor(next) {
    const url = new URL(location.href);
    url.searchParams.set('page', next);
    category === 'all' ? url.searchParams.delete('bar_filter') : url.searchParams.set('bar_filter', category);
    url.searchParams.delete('filter');
    query ? url.searchParams.set('bar_q', query) : url.searchParams.delete('bar_q');
    url.hash = 'the-bar-products';
    return url;
  }
  function render(updateUrl = false) {
    const matches = cards.filter(card =>
      (category === 'all' || (card.dataset.tags || '').split(' ').includes(category)) &&
      (!query || normalize(card.dataset.search || '').includes(normalize(query))));
    const pages = Math.max(1, Math.ceil(matches.length / size));
    page = Math.min(Math.max(1, page), pages);
    const visible = new Set(matches.slice((page - 1) * size, page * size));
    cards.forEach(card => { card.classList.toggle('is-hidden', !visible.has(card)); });
    document.querySelector('.sa2-coll-bar__count-num').textContent = matches.length;
    document.querySelector('.sa2-coll-bar__count-label').textContent = matches.length === 1 ? 'sample' : 'samples';
    empty.hidden = matches.length !== 0;
    clear.hidden = !query;
    buttons.forEach(button => {
      const selected = button.dataset.filter === category;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    pager.replaceChildren();
    for (let index = 1; index <= pages; index++) {
      const link = document.createElement('a');
      link.href = urlFor(index).href;
      link.textContent = String(index);
      link.className = 'sa2-coll-pag__link';
      link.dataset.barPage = index;
      link.setAttribute('aria-label', `Page ${index}`);
      if (index === page) link.setAttribute('aria-current', 'page');
      pager.append(link);
    }
    pager.style.cssText = 'display:flex;justify-content:center;flex-wrap:wrap;gap:16px';
    pager.hidden = pages < 2;
    if (updateUrl) history.pushState({}, '', urlFor(page));
  }
  filters.addEventListener('click', event => {
    const button = event.target.closest('[data-filter]');
    if (!ready || !button) return;
    category = button.dataset.filter;
    page = 1;
    render(true);
  });
  search.addEventListener('input', () => {
    if (!ready) return;
    query = search.value.trim();
    page = 1;
    render();
    history.replaceState({}, '', urlFor(page));
  });
  clear.addEventListener('click', () => {
    search.value = query = '';
    page = 1;
    render(true);
    search.focus();
  });
  pager.addEventListener('click', event => {
    const link = event.target.closest('[data-bar-page]');
    if (!ready || !link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    page = Number(link.dataset.barPage);
    render(true);
    grid.closest('section').scrollIntoView({behavior: 'instant'});
    pager.querySelector('[aria-current]').focus({preventScroll: true});
  });
  window.addEventListener('popstate', () => {
    if (!ready) return;
    const state = new URLSearchParams(location.search);
    category = state.get('bar_filter') || state.get('filter') || 'all';
    query = state.get('bar_q') || '';
    page = Number(state.get('page')) || 1;
    search.value = query;
    render();
  });
  const sort = document.querySelector('[data-sa2-sort-form] select');
  if (sort) sort.addEventListener('change', () => {
    const url = urlFor(1);
    url.searchParams.set('sort_by', sort.value);
    location.assign(url);
  });
  // Load every server page before enabling catalog-wide filters. Native links
  // remain available if loading fails, so incomplete results cannot look complete.
  async function initialize() {
    enableControls(false);
    if (loading) { loading.hidden = false; loading.textContent = 'Loading fragrance search'; }
    try {
      const batches = new Map([[initialPage, [...grid.querySelectorAll('[data-sa2-card]')]]]);
      for (let index = 1; index <= totalPages; index++) {
        if (index === initialPage) continue;
        const url = new URL(location.href);
        url.searchParams.set('page', index);
        url.searchParams.set('section_id', pager.dataset.sectionId);
        const response = await fetch(url, {credentials: 'same-origin'});
        if (!response.ok) throw new Error('Collection unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const batch = [...doc.querySelectorAll('[data-sa2-card]')];
        if (!batch.length) throw new Error('Missing collection page');
        batches.set(index, batch);
      }
      cards = [...batches.entries()].sort((a,b) => a[0]-b[0]).flatMap(entry => entry[1]);
      const countEl = document.querySelector('.sa2-coll-bar__count-num');
      const restEl = document.querySelector('.sa2-coll-bar__count-rest');
      const restMatch = restEl ? restEl.textContent.match(/\d+/) : null;
      const expected = (Number(countEl ? countEl.textContent : 0) || 0) + (restMatch ? Number(restMatch[0]) : 0);
      if (new Set(cards.map(card => card.getAttribute('href'))).size !== expected) throw new Error('Incomplete collection');
      if (!params.has('sort_by') || params.get('sort_by') === 'manual') {
        const rank = card => /(^| )(starter-set|bundle)( |$)/.test(card.dataset.tags) ? 2 : /(^| )most-popular( |$)/.test(card.dataset.tags) ? 0 : 1;
        cards.sort((a,b) => rank(a)-rank(b));
      }
      cards.forEach(card => {
        card.classList.remove('sa2-reveal');
        grid.append(card);
      });
      search.value = query;
      ready = true;
      render();
      enableControls(true);
      if (loading) loading.hidden = true;
    } catch (_) {
      if (loading) loading.textContent = 'Search is temporarily unavailable. Browse the pages below or reload to try again.';
    }
  }
  initialize();
})();
